import { useEffect, useState } from 'react';
import api from '../utils/api';

export default function HistoryPage() {
  const [matches, setMatches] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/match/history').then(r => setMatches(r.data.matches || [])).finally(() => setLoading(false));
  }, []);

  const loadMatch = async (id) => {
    const res = await api.get(`/match/${id}`);
    setSelected(res.data.match);
  };

  if (loading) return <div className="page"><p style={{ color: 'var(--muted)' }}>Loading history...</p></div>;

  return (
    <div className="page">
      <div style={{ marginBottom: 32 }}>
        <div style={{ fontFamily: 'Syne', fontSize: 26, fontWeight: 800, marginBottom: 8 }}>📊 Match History</div>
        <p style={{ color: 'var(--muted)', fontSize: 14 }}>{matches.length} total analyses</p>
      </div>

      {matches.length === 0 ? (
        <div className="card" style={{ textAlign: 'center', padding: '60px 32px' }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}>📭</div>
          <div style={{ fontFamily: 'Syne', fontSize: 18, fontWeight: 700, marginBottom: 8 }}>No history yet</div>
          <p style={{ color: 'var(--muted)', fontSize: 14 }}>Run your first analysis to see results here.</p>
        </div>
      ) : (
        <div className="two-col" style={{ alignItems: 'flex-start' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {matches.map(match => {
              const score = match.result?.overallScore || 0;
              const badgeCls = score >= 70 ? 'badge-green' : score >= 45 ? 'badge-yellow' : 'badge-red';
              const isActive = selected?._id === match._id;
              return (
                <div key={match._id} onClick={() => loadMatch(match._id)}
                  style={{ background: isActive ? 'var(--surface2)' : 'var(--surface)', border: `1px solid ${isActive ? 'var(--accent)' : 'var(--border)'}`, borderRadius: 12, padding: '16px 20px', cursor: 'pointer', transition: 'all 0.2s' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div>
                      <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 14, marginBottom: 2 }}>
                        {match.customJobTitle || match.job?.title || 'Custom JD'}
                      </div>
                      <div style={{ fontSize: 12, color: 'var(--muted)' }}>
                        {match.customCompany || match.job?.company || '—'} · {new Date(match.createdAt).toLocaleDateString()}
                      </div>
                    </div>
                    <span className={`badge ${badgeCls}`}>{score}%</span>
                  </div>
                </div>
              );
            })}
          </div>

          <div>
            {selected ? (
              <div className="card" style={{ marginBottom: 0 }}>
                <div style={{ fontFamily: 'Syne', fontSize: 18, fontWeight: 800, marginBottom: 4 }}>{selected.result?.verdict}</div>
                <p style={{ color: 'var(--muted)', fontSize: 13, lineHeight: 1.8, marginBottom: 20 }}>{selected.result?.summary}</p>

                <div className="section-title">Matched Skills</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 20 }}>
                  {(selected.result?.matchedSkills || []).map(s => <span key={s} className="tag tag-green">{s}</span>)}
                </div>

                <div className="section-title">Missing Skills</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                  {(selected.result?.missingSkills || []).map(s => <span key={s} className="tag tag-red">{s}</span>)}
                </div>
              </div>
            ) : (
              <div className="card" style={{ textAlign: 'center', padding: '48px 24px', marginBottom: 0 }}>
                <div style={{ fontSize: 32, marginBottom: 12 }}>👈</div>
                <p style={{ color: 'var(--muted)', fontSize: 14 }}>Click an analysis to view details</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
